import type { ReactNode } from 'react'
import { memo } from 'react'

import { Button } from '@/components/ui/button'

export interface NotificationHeaderProps {
  hasUnread: boolean
  onMarkAllRead?: () => void
}

const NotificationHeaderBase: React.FC<NotificationHeaderProps> = ({
  hasUnread,
  onMarkAllRead,
}): ReactNode => {
  return (
    <div className="notification-header flex items-center justify-between border-b px-4 py-3">
      <h3 className="text-sm font-semibold">Notifications</h3>
      {hasUnread && onMarkAllRead && (
        <Button
          variant="ghost"
          size="sm"
          className="h-auto py-1 px-2 text-xs text-muted-foreground hover:text-foreground"
          onClick={onMarkAllRead}
        >
          Mark all as read
        </Button>
      )}
    </div>
  )
}

export const NotificationHeader = memo(NotificationHeaderBase)

NotificationHeader.displayName = 'NotificationHeader'
